import React from 'react';
import './departement.css';
import { Footer, Header } from '../index';
import { Link } from 'react-router-dom';
import directeur from'../../asserts/images/directeurinfo.jpg';

function Departementinfo(props) {
  return (
    <div style={{ backgroundColor: '#FCFCFC' }}>
      <Header/>
      <div className='containerINFO'>
        <div className='bgINFO'>  </div>
        <div className="container-fluid text-white text-center" style={{ position: 'relative', marginTop: '-160px', marginBottom: '100px' }}>
          <h1 style={{fontFamily:'fantasy', fontSize:'45px'}}className="container-fluid text-white text-center " id='h1info'>Département Informatique</h1>
          <p ><Link className='linkdep' to="/">Accueil</Link> <span>{'>'}</span><Link className='linkdep'
            to="/"> Département </Link>  <span>{'>'}</span> <Link className='linkdep'
            to="/">Informatique</Link></p></div>
      </div>
      <div className="DEP" >
          
          <div className='boxdep1'>
            <h1 className="container-fluid text-center" style={{color:'#162533' }}>Directeur De Département</h1>
            <div className='pres'>
              <div className='IMAGE'>    
                  <img src={directeur} alt="intro" />               
              </div>
              <div className='coordonne'><p><span>Nom : </span>Lazhar Hamel <br/> <span>Email : </span><a href=''>lazhar.hamel@gmail.com</a> </p> </div>
            </div>
          </div>
          <div className="vertical-line"></div> {/* Ligne verticale */}
          <div className='boxdep2'>
           <h1 className="container-fluid text-center" style={{color:'#162533' }}>Présentation</h1>
             <p className='parag'>
             <br/>
            Le département d'informatique à l'Institut Supérieur d'Informatique et de Mathématiques
            de Monastir(ISIMM) se distingue par son engagement à offrir une formation 
            de haute qualité dans le domaine de l'informatique. Avec un corps professoral expérimenté 
            et passionné, le département s'efforce de fournir aux étudiants les connaissances
            théoriques et pratiques nécessaires pour exceller dans un environnement technologique en 
            constante évolution. Grâce à des programmes d'études innovants et à des laboratoires
              bien équipés, les étudiants de L'ISIMM acquièrent des compétences pertinentes et actualisées, 
              les préparant ainsi à relever les défis complexes du monde numérique d'aujourd'hui.
             </p>
          </div>
        </div>
      <Footer />
    </div>
  )
}

export default Departementinfo;
 /*<a target="_blank" href="/images/organigramme.jpg">
    </a>*/